"use client"

import React from "react"
import { useToast } from "../../hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "../../components/ui/toast"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  React.useEffect(() => {
    return () => {
      toasts.forEach(t => dismiss(t.id))
    }
  }, [])

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <div key={id}>
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[1199] pointer-events-auto" />
            <Toast variant={variant} {...props}>
              <div className="w-full text-center">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose />
            </Toast>
          </div>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}